// frontend/src/site/builder/sections/SobreForm.jsx
import React from 'react';

function Label({ children }) {
  return <div className="text-sm font-medium text-gray-800">{children}</div>;
}
function Input({ value, onChange, placeholder = '' }) {
  return (
    <input
      value={value || ''}
      onChange={(e) => onChange?.(e.target.value)}
      placeholder={placeholder}
      className="mt-2 w-full px-3 py-2 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-black/10"
    />
  );
}
function Textarea({ value, onChange, placeholder = '' }) {
  return (
    <textarea
      value={value || ''}
      onChange={(e) => onChange?.(e.target.value)}
      placeholder={placeholder}
      className="mt-2 w-full px-3 py-2 rounded-lg border border-gray-200 min-h-[130px] focus:outline-none focus:ring-2 focus:ring-black/10"
    />
  );
}

export default function SobreForm({ value = {}, onChange }) {
  const v = value || {};
  const diferenciais = Array.isArray(v.diferenciais) ? v.diferenciais : [];

  function patch(p) {
    onChange?.(p);
  }

  function setDif(i, val) {
    const next = [...diferenciais];
    next[i] = val;
    patch({ diferenciais: next });
  }

  function addDif() {
    patch({ diferenciais: [...diferenciais, ''] });
  }

  function removeDif(i) {
    const next = diferenciais.filter((_, idx) => idx !== i);
    patch({ diferenciais: next });
  }

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div className="md:col-span-2">
          <Label>Mini bio profissional</Label>
          <Textarea
            value={v.bio}
            onChange={(x) => patch({ bio: x })}
            placeholder="Ex: Sou corretor apaixonado por conectar pessoas..."
          />
        </div>

        <div>
          <Label>Tempo de mercado</Label>
          <Input
            value={v.tempoMercado}
            onChange={(x) => patch({ tempoMercado: x })}
            placeholder="Ex: 15 anos"
          />
        </div>

        <div>
          <Label>Área de atuação</Label>
          <Input
            value={v.areaAtuacao}
            onChange={(x) => patch({ areaAtuacao: x })}
            placeholder="Ex: Sinop - MT e região"
          />
        </div>

        <div className="md:col-span-2">
          <Label>Diferenciais (lista)</Label>

          <div className="mt-2 space-y-2">
            {diferenciais.map((d, i) => (
              <div key={i} className="flex gap-2">
                <input
                  value={d || ''}
                  onChange={(e) => setDif(i, e.target.value)}
                  placeholder="Ex: Segurança jurídica"
                  className="flex-1 px-3 py-2 rounded-lg border border-gray-200"
                />
                <button
                  type="button"
                  onClick={() => removeDif(i)}
                  className="px-3 py-2 rounded-lg border border-gray-200 hover:bg-gray-50 text-sm"
                >
                  Remover
                </button>
              </div>
            ))}

            <button
              type="button"
              onClick={addDif}
              className="px-3 py-2 rounded-lg bg-black text-white hover:opacity-90 text-sm"
            >
              + Adicionar diferencial
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
